import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scannerUpdateAtom = createMutationAtomFactory(
  'settings.scannerUpdate',
  (params: { id: string; name?: string }) => ({
    iotScannerUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
        },
      },
      id: true,
      name: true,
      status: true,
    },
  }),
);
